import React from 'react';

const Pagination = ({ page, totalItems, itemsPerPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // console.log(totalItems,'total')

  const handleClick = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      onPageChange(newPage);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 3;

    if (totalPages <= maxVisiblePages * 2 + 2) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(
          <button
            key={i}
            className={`mx-1 px-3 py-1 border rounded ${
              page === i ? 'bg-blue-500 text-white' : 'bg-white text-blue-500 border-blue-500'
            }`}
            onClick={() => handleClick(i)}
          >
            {i}
          </button>
        );
      }
    } else {
      if (page <= maxVisiblePages) {
        for (let i = 1; i <= maxVisiblePages + 1; i++) {
          pageNumbers.push(
            <button
              key={i}
              className={`mx-1 px-3 py-1 border rounded ${
                page === i ? 'bg-blue-500 text-white' : 'bg-white text-blue-500 border-blue-500'
              }`}
              onClick={() => handleClick(i)}
            >
              {i}
            </button>
          );
        }
        pageNumbers.push(<span key="dots1" className="mx-1">...</span>);
        pageNumbers.push(
          <button
            key={totalPages}
            className={`mx-1 px-3 py-1 border rounded bg-white text-blue-500 border-blue-500`}
            onClick={() => handleClick(totalPages)}
          >
            {totalPages}
          </button>
        );
      } else if (page > totalPages - maxVisiblePages) {
        pageNumbers.push(
          <button
            key={1}
            className={`mx-1 px-3 py-1 border rounded bg-white text-blue-500 border-blue-500`}
            onClick={() => handleClick(1)}
          >
            1
          </button>
        );
        pageNumbers.push(<span key="dots2" className="mx-1">...</span>);
        for (let i = totalPages - maxVisiblePages; i <= totalPages; i++) {
          pageNumbers.push(
            <button
              key={i}
              className={`mx-1 px-3 py-1 border rounded ${
                page === i ? 'bg-blue-500 text-white' : 'bg-white text-blue-500 border-blue-500'
              }`}
              onClick={() => handleClick(i)}
            >
              {i}
            </button>
          );
        }
      } else {
        pageNumbers.push(
          <button
            key={1}
            className={`mx-1 px-3 py-1 border rounded bg-white text-blue-500 border-blue-500`}
            onClick={() => handleClick(1)}
          >
            1
          </button>
        );
        pageNumbers.push(<span key="dots3" className="mx-1">...</span>);
        for (let i = page - 1; i <= page + 1; i++) {
          pageNumbers.push(
            <button
              key={i}
              className={`mx-1 px-3 py-1 border rounded ${
                page === i ? 'bg-blue-500 text-white' : 'bg-white text-blue-500 border-blue-500'
              }`}
              onClick={() => handleClick(i)}
            >
              {i}
            </button>
          );
        }
        pageNumbers.push(<span key="dots4" className="mx-1">...</span>);
        pageNumbers.push(
          <button
            key={totalPages}
            className={`mx-1 px-3 py-1 border rounded bg-white text-blue-500 border-blue-500`}
            onClick={() => handleClick(totalPages)}
          >
            {totalPages}
          </button>
        );
      }
    }

    return pageNumbers;
  };

  return (
    <div className="flex items-center justify-center">
      <button
        onClick={() => handleClick(page - 1)}
        disabled={page === 1}
        className="mx-1 px-3 py-1 border rounded bg-white text-blue-500 border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Previous
      </button>
      {renderPageNumbers()}
      <button
        onClick={() => handleClick(page + 1)}
        disabled={page === totalPages}
        className="mx-1 px-3 py-1 border rounded bg-white text-blue-500 border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
